var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zone-list',{attrs:{"getParams":_vm.getParams,"disable-create":_vm.data.provider !== 'OneCloud',"hidden-actions":['create'],"id":"ZoneListForCloudregionSidePage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }